'use strict';

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createMarker = createMarker;
exports.quiqee = quiqee;
exports.waypoint = waypoint;
exports.isObject = isObject;

var _inlineStyle = require('inline-style');

var _inlineStyle2 = _interopRequireDefault(_inlineStyle);

var _theme = require('../../../styles/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var bikeImg = require('./assets/bicycle.png');
var carImg = require('./assets/car.png');
var scooterImg = require('./assets/scooter.png');
var vanImg = require('./assets/van.png');

exports.default = {
  quiqee: quiqee,
  waypoint: waypoint
};


var markerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginLeft: '-50%',
  marginTop: '-33px',
  position: 'relative'
};

var headerStyle = {
  position: 'relative',
  display: 'flex',
  backgroundColor: _theme2.default.midnight500,
  minWidth: '46px',
  height: '46px',
  borderRadius: '46px',
  boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.1)',
  cursor: 'pointer',
  alignItems: 'center'
};

var headerText = {
  color: 'white',
  paddingRight: '24px',
  fontSize: '16px',
  display: 'flex',
  alignItems: 'baseline'
};

var headerTextSuffix = {
  fontSize: '12px'
};

var headerIconStyle = {
  width: '46px',
  height: '46px',
  backgroundRepeat: 'no-repeat',
  backgroundSize: '24px',
  backgroundPosition: 'center',
  color: 'white'
};

var lineStyle = {
  backgroundColor: _theme2.default.midnight500,
  display: 'block',
  width: '2px',
  height: '10px',
  boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.1)'
};

var pointStyle = {
  backgroundColor: _theme2.default.midnight500,
  display: 'block',
  width: '6px',
  height: '6px',
  borderRadius: '100%',
  boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.1)'
};

var textStyle = {
  backgroundColor: '#212339',
  color: '#fff',
  borderRadius: '100px',
  textAlign: 'center',
  fontSize: '12px',
  fontWeight: '300',
  border: '1px solid #fff',
  marginTop: '-25px',
  whiteSpace: 'nowrap',
  padding: '0 8px',
  display: 'block',
  position: 'relative',
  zIndex: 1,
  cursor: 'pointer',
  bottom: '-10px'
};

var badgeStyles = {
  position: 'absolute',
  background: _theme2.default.navy,
  borderRadius: '50%',
  fontSize: '10.5px',
  zIndex: '1',
  color: '#fff',
  top: '-7px',
  right: '-22px',
  height: '25px',
  width: '25px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

function createMarker(className) {
  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var text = arguments[2];
  var markerLabel = arguments[3];
  var badge = arguments[4];

  style = Object.assign({}, { marker: {}, header: {}, line: {}, point: {}, text: {} }, style);

  var imageUrl = style.header.backgroundImage;
  // badgeStyles is mutated when this function is called again, so I need to reset it
  badgeStyles.top = '-7px';
  badgeStyles.right = '-22px';

  if (!style.iconHeader) {
    style.iconHeader = {};
  }

  style.iconHeader.backgroundImage = imageUrl;

  if (!markerLabel) {
    markerLabel = {};
  }

  if (markerLabel.text) {
    style.iconHeader.width = '32px';
    style.iconHeader.marginRight = '6px';
    style.iconHeader.backgroundPosition = 'right';
    style.iconHeader.backgroundSize = '16px';
    // badgeStyles is mutated here
    badgeStyles.top = '-14px';
    badgeStyles.right = '-4px';
  }

  var labelTextElement = '\n    <span style="' + (0, _inlineStyle2.default)(headerText) + '">\n      ' + markerLabel.text + '\n      ' + (markerLabel.suffix && '\n        <div style="' + (0, _inlineStyle2.default)(headerTextSuffix) + '">\n          ' + markerLabel.suffix + '\n        </div>\n      ') + '\n    </span>\n  ';

  var textElement = '\n    <span class="' + className + '-text" style="' + (0, _inlineStyle2.default)(mergeDeep(textStyle, style.text)) + '">' + text + '</span>\n  ';

  var badgeElement = '<span class="badge" style="' + (0, _inlineStyle2.default)(mergeDeep(badgeStyles)) + '">' + badge + '</span>';

  return '<span class="' + className + '" style="' + (0, _inlineStyle2.default)(mergeDeep(markerStyle)) + '">\n      ' + (badge ? badgeElement : '') + '\n      <div\n        class="' + className + '-header"\n        style="' + (0, _inlineStyle2.default)(mergeDeep(headerStyle, _extends({}, style.header, { backgroundImage: null }))) + '">\n        <div style="' + (0, _inlineStyle2.default)(mergeDeep(headerIconStyle, style.iconHeader)) + '"></div>\n        ' + (markerLabel.text ? labelTextElement : '') + '\n      </div>\n      ' + (text ? textElement : '') + '\n      <span class="' + className + '-line" style="' + (0, _inlineStyle2.default)(mergeDeep(lineStyle, style.line)) + '"></span>\n      <span class="' + className + '-point" style="' + (0, _inlineStyle2.default)(mergeDeep(pointStyle, style.point)) + '"></span>\n    </span>';
}

/**
 * The quiqee definition.
 *
 * @return {String} - String with the html for quiqee Marker.
 */
function quiqee(styles, text, transportMode) {
  var quiqeeStyles = {
    header: { backgroundColor: _theme2.default.green },
    line: { backgroundColor: _theme2.default.green },
    point: { backgroundColor: _theme2.default.green }
  };

  switch (transportMode) {
    case 'van':
      quiqeeStyles.header.backgroundImage = 'url(' + vanImg + ')';
      break;
    case 'car':
      quiqeeStyles.header.backgroundImage = 'url(' + carImg + ')';
      break;
    case 'bicycle':
      quiqeeStyles.header.backgroundImage = 'url(' + bikeImg + ')';
      break;
    default:
      quiqeeStyles.header.backgroundImage = 'url(' + scooterImg + ')';
  }

  return createMarker('quiqee-marker', mergeDeep(quiqeeStyles, styles), text);
}

/**
 * The waypoint definition.
 *
 * @return {String} - String with the html for waypoint Marker.
 */
function waypoint(styles, text, markerLabel, badge) {
  return createMarker('waypoint-marker', styles, text, markerLabel, badge);
}

function isObject(item) {
  return item && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && !Array.isArray(item) && item !== null;
}

function mergeDeep(target, source) {
  var output = Object.assign({}, target);

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(function (key) {
      if (isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, _defineProperty({}, key, source[key]));
        } else {
          output[key] = mergeDeep(target[key], source[key]);
        }
      } else {
        Object.assign(output, _defineProperty({}, key, source[key]));
      }
    });
  }
  return output;
}

function calculateLabelPosition(text) {
  var thinChars = text.match(/[,jliI':.| ]/g);
  var widerChars = text.match(/[^,jliI':.| ]/g);

  thinChars = thinChars ? thinChars.length : 0;
  widerChars = widerChars ? widerChars.length : 0;

  var position = thinChars * 1.5 + widerChars * 3;

  if (position > 9) {
    position = position - 9 + 'px';
  } else {
    position = '0px';
  }

  return position;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/qu-react-sdk/lib/components/qu-map/markers/markers.js
// module id = 855
// module chunks = 0